<template>
  <dialog-v2
    :show="dialog"
    title="Seleccione una plantilla"
    max-width="450px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="botTemplateId"
            :items="botTemplates"
            item-value="id"
            item-text="name"
            v-validate="'required'"
            data-vv-name="botTemplateId"
            data-vv-scope="botTemplate"
            data-vv-as="plantilla"
            :error-messages="errors.collect('botTemplate.botTemplateId')"
            label="Nombre"
            color="black"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import { setTimeout } from 'timers';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    selected: {
      required: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    return {
      dialog: false,
      botTemplates: [],
      botTemplateId: null,
    };
  },
  methods: {
    save() {
      this.$validator.validateAll('botTemplate').then((validation) => {
        if (validation) {
          this.$emit('save', this.botTemplateId);
          this.$emit('close');
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show && !this.botTemplates.length) {
        this.axios.get('bot_templates?paginate=0&status=Activo').then((response) => {
          this.botTemplates = response.data.map(item => ({
            id: item.id,
            name: item.name,
          }));
          this.botTemplateId = this.selected;
          this.dialog = true;
        });
      } else if (!this.show) {
        setTimeout(() => {
          this.botTemplateId = null;
          this.$validator.errors.remove('botTemplateId', 'botTemplate');
        }, 200);
        this.dialog = false;
      } else {
        this.botTemplateId = this.selected;
        this.dialog = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Templates/BotTemplates.vue